// extracted by mini-css-extract-plugin
export var background = "b0_gm";
export var body = "b0_fX";
export var button = "b0_b1";
export var card = "b0_dl";
export var content = "b0_9";
export var footer = "b0_gn";
export var header = "b0_gl";
export var subtitle = "b0_f1";
export var title = "b0_bp";